import { FeaturedJob } from 'rwl-shared/dist/models';

export const serializeMedia = (job: FeaturedJob) =>
    (job.media || []).map((media) => ({
        id: media.id,
        type: media.type,
        thumbnailUrl: media.thumbnailUrl,
        sourceUrl: media.sourceUrl,
        sortOrder: media.sortOrder,
    }));
